import { useSelector } from 'react-redux';
import useUserInfo from './useTtsUser';

const useTotalCredits = () => {
  const remainingCharacters = useSelector(
    (state) => state.auth.user?.remainingCharacters ?? 0,
  );
  const bonusCharacters = useSelector(
    (state) => state.auth.user?.bonusCharacters ?? 0,
  );
  const { ttsUser } = useUserInfo();

  const { studio } = ttsUser;
  const { cycle = {}, topUp = {}, custom = {} } = studio || {};
  const {
    remainingCredits: remainingCycleCredits = 0,
    capturedRolloverCredits: capturedRolloverCreditsCycle = 0,
    capturedReferralCredits: capturedReferralCreditsCycle = 0,
    creditsPerCycle,
    purchasedTopUpCredits,
    apiUsedCredits: totalRemainingApiCredits = 0,
  } = cycle;
  const {
    remainingCredits: remainingTopUpCredits = 0,
    capturedRolloverCredits: capturedRolloverCreditsTopUp = 0,
  } = topUp;
  const { remainingCredits: remainingCustomCredits = 0 } = custom;

  const totalCredits =
    remainingCharacters +
    bonusCharacters +
    remainingCycleCredits +
    remainingTopUpCredits +
    remainingCustomCredits;

  // Remaining credits usable through API, exclude V2 package and bonus characters
  const totalApiCredits =
    remainingCycleCredits + remainingTopUpCredits + remainingCustomCredits;

  // limit credits api
  const totalCapturedRolloverCredits =
    capturedRolloverCreditsCycle + capturedRolloverCreditsTopUp;
  const totalCreditsPackage =
    creditsPerCycle +
    purchasedTopUpCredits +
    totalCapturedRolloverCredits +
    capturedReferralCreditsCycle;

  const apiLimitTotal = Math.round(totalCreditsPackage * 0.5); // Simplified - should come from API
  const apiLimitRemaining = Math.min(
    apiLimitTotal - totalRemainingApiCredits,
    totalApiCredits,
  ); // Simplified

  return { totalCredits, apiLimitRemaining };
};

export default useTotalCredits;
